/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

export enum ConstraintFormControlStates {
	NO_ACCESS = 'noAccess',
	REQUESTED_BY_MEMBER = 'requestedByMember',
	ASSIGNED_TO_MEMBER = 'assignedToMember',
	IS_ADMIN = 'isAdmin',
	IS_CREATOR = 'isCreator',
}
